export enum ReviewStatusEnum {
  NOT_STARTED = 'NOT_STARTED',
  COMPLETED = 'COMPLETED',
}
